import React from 'react';
import { Facebook, Instagram, Twitter, Mail, Phone, MapPin } from 'lucide-react';

const Footer: React.FC = () => {
  return (
    <footer className="bg-dark text-light pt-16 pb-8">
      <div className="container">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-12">
          {/* Logo y descripción */}
          <div>
            <h2 className="text-2xl font-serif font-bold text-white mb-4">LuxuryEstates</h2>
            <p className="text-gray-300 mb-6">
              Especialistas en propiedades exclusivas y de lujo. Ofrecemos un servicio personalizado
              para encontrar el hogar de sus sueños.
            </p>
            <div className="flex space-x-4">
              <a href="#" className="text-gray-300 hover:text-secondary transition-colors">
                <Facebook size={20} />
              </a>
              <a href="#" className="text-gray-300 hover:text-secondary transition-colors">
                <Instagram size={20} />
              </a>
              <a href="#" className="text-gray-300 hover:text-secondary transition-colors">
                <Twitter size={20} />
              </a>
            </div>
          </div>

          {/* Enlaces rápidos */}
          <div>
            <h3 className="text-lg font-bold text-white mb-4">Enlaces rápidos</h3>
            <ul className="space-y-3">
              <li>
                <a href="#" className="text-gray-300 hover:text-secondary transition-colors">Inicio</a>
              </li>
              <li>
                <a href="#" className="text-gray-300 hover:text-secondary transition-colors">Propiedades</a>
              </li>
              <li>
                <a href="#" className="text-gray-300 hover:text-secondary transition-colors">Nosotros</a>
              </li>
              <li>
                <a href="#" className="text-gray-300 hover:text-secondary transition-colors">Testimonios</a>
              </li>
              <li>
                <a href="#" className="text-gray-300 hover:text-secondary transition-colors">Contacto</a>
              </li>
            </ul>
          </div>

          {/* Contacto */}
          <div>
            <h3 className="text-lg font-bold text-white mb-4">Contacto</h3>
            <ul className="space-y-3">
              <li className="flex items-center space-x-3">
                <MapPin size={18} className="text-secondary" />
                <span className="text-gray-300">Av. Principal 123, Ciudad</span>
              </li>
              <li className="flex items-center space-x-3">
                <Phone size={18} className="text-secondary" />
                <span className="text-gray-300">+34 912 345 678</span>
              </li>
              <li className="flex items-center space-x-3">
                <Mail size={18} className="text-secondary" />
                <span className="text-gray-300">info@luxuryestates.com</span>
              </li>
            </ul>
          </div>
        </div>

        {/* Línea divisoria */}
        <div className="border-t border-gray-700 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <p className="text-gray-400 text-sm mb-4 md:mb-0">
              © {new Date().getFullYear()} LuxuryEstates. Todos los derechos reservados.
            </p>
            <div className="flex space-x-6">
              <a href="#" className="text-gray-400 hover:text-secondary text-sm transition-colors">
                Política de privacidad
              </a>
              <a href="#" className="text-gray-400 hover:text-secondary text-sm transition-colors">
                Términos y condiciones
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;